<script lang="ts">
  import 'simplebar';
  import 'simplebar/dist/simplebar.css';
  import type { STREAM } from '$src/utils/api/admin/streams.util';
  import dayjs from 'dayjs';
  import relativeTime from 'dayjs/plugin/relativeTime';

  dayjs.extend(relativeTime);

  export let stream: STREAM;

  const code = stream?.stream?.split('live')[1]?.split('/')[1]?.replace('?feature=share', '');
  // stream.stream : https://youtube.com/live/INjvcxa62tI?feature=share
</script>

{#if stream && new Date(stream?.endDate).getTime() > Date.now()}
  <button
    on:click={() => {
      window.open(`${stream?.stream}`, '_blank');
    }}
    class="w-full cursor-pointer h-[73px] p-2 flex items-center justify-center text-left mb-2 {stream?.isLive
      ? 'bg-gradient-to-l from-rose-100 via-white to-white'
      : 'bg-[linear-gradient(270deg,_#ebf6f1_0%,#ffffff_35%,#ffffff_100%)] '}  rounded-2xl border border-neutral-800 border-opacity-10"
  >
    <iframe
      class="w-[86px] h-[57px] rounded-[10px] border border-gray-300 pointer-events-none"
      title="stream"
      allow="accelerometer;fullScreen; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
      src="https://www.youtube.com/embed/{code}?autoplay=1&mute=1&controls=0&rel=0"
    />
    <div class="pl-2 w-full flex flex-col gap-5">
      <div class="text-neutral-800 text-sm font-medium leading-tight">
        {stream?.title}
      </div>
      {#if stream?.isLive}
        <div class="w-full flex items-center justify-between">
          <div class="flex items-end text-center text-green-600 text-xs font-bold leading-tight">
            WATCH NOW <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 12L10 8L6 4"
                stroke="#0F9D58"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <div
            class="w-12 h-5 pl-1 pr-1.5 py-0.5 bg-red-100 rounded flex-col justify-start items-start gap-2 inline-flex"
          >
            <div class="justify-start items-center gap-1 inline-flex">
              <div class="w-2 h-2 bg-rose-700 rounded-full" />
              <div class="text-rose-700 text-xs font-bold">LIVE</div>
            </div>
          </div>
        </div>
      {:else}
        <div class="flex">
          <div class="bg-garden-grey-100 flex items-center rounded-lg">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.00016 1.33337C4.32683 1.33337 1.3335 4.32671 1.3335 8.00004C1.3335 11.6734 4.32683 14.6667 8.00016 14.6667C11.6735 14.6667 14.6668 11.6734 14.6668 8.00004C14.6668 4.32671 11.6735 1.33337 8.00016 1.33337ZM10.9002 10.38C10.8068 10.54 10.6402 10.6267 10.4668 10.6267C10.3802 10.6267 10.2935 10.6067 10.2135 10.5534L8.14683 9.32004C7.6335 9.01337 7.2535 8.34004 7.2535 7.74671V5.01337C7.2535 4.74004 7.48016 4.51337 7.7535 4.51337C8.02683 4.51337 8.2535 4.74004 8.2535 5.01337V7.74671C8.2535 7.98671 8.4535 8.34004 8.66016 8.46004L10.7268 9.69337C10.9668 9.83337 11.0468 10.14 10.9002 10.38Z"
                fill="#47675B"
              />
            </svg>
            <div
              class=" text-center whitespace-nowrap text-xs font-['Satoshi'] font-bold leading-[20px] text-garden-grey-600 w-32"
            >
              {new Date(stream?.date).getTime() > Date.now() ? 'Starting in ' : 'Started'}

              {dayjs(new Date(stream?.date)).fromNow()}
            </div>
          </div>
        </div>
      {/if}
    </div>
  </button>
{/if}
